import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";

const msall_instance = new PublicClientApplication({
  auth: {
    clientId: "a48c1d54-11b9-4ad7-a2b2-daa7b427ac82",
    authority:
      "https://login.microsoftonline.com/94255380-32ab-42e5-b722-359bb4a13c0f",
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msall_instance}>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={{scopes: ["api://a48c1d54-11b9-4ad7-a2b2-daa7b427ac82/api_copilotGT"]}}
        // errorComponent={ErrorComponent}
        // loadingComponent={LoadingComponent}
      >
        <App />
      </MsalAuthenticationTemplate>
    </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
